import React from 'react';
import { motion } from 'framer-motion';
export const ProductPresentation = () => {
  return <section className="py-24 bg-cream relative overflow-hidden" data-id="element-325">
      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-326">
        <div className="text-center mb-16" data-id="element-327">
          <span className="text-brand-600 font-bold tracking-widest uppercase text-sm mb-4 block" data-id="element-328">
            — LA SOLUCIÓN —
          </span>
          <h2 className="text-5xl sm:text-6xl font-bold text-neutral-900 mb-6 tracking-tight" data-id="element-329">
            CAJA DE COBRO
          </h2>
          <p className="text-2xl sm:text-3xl font-medium text-neutral-700 text-balance" data-id="element-330">
            El Sistema para Generar Ventas cuando "Nadie tiene un Mango"
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-331">
          {/* Esto NO es */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-xl p-8 border border-neutral-200 shadow-sm" data-id="element-332">
            <h3 className="text-xl font-bold text-neutral-700 mb-6" data-id="element-333">
              Esto NO es:
            </h3>
            <ul className="space-y-4" data-id="element-334">
              <li className="flex items-start gap-3 text-neutral-600" data-id="element-335">
                <span className="mt-1" data-id="element-336">❌</span>
                <span data-id="element-337">Un curso de motivación con frases bonitas</span>
              </li>
              <li className="flex items-start gap-3 text-neutral-600" data-id="element-338">
                <span className="mt-1" data-id="element-339">❌</span>
                <span data-id="element-340">Un ebook genérico traducido del inglés</span>
              </li>
              <li className="flex items-start gap-3 text-neutral-600" data-id="element-341">
                <span className="mt-1" data-id="element-342">❌</span>
                <span data-id="element-343">Teoría de negocios que suena bien pero no se aplica</span>
              </li>
              <li className="flex items-start gap-3 text-neutral-600" data-id="element-344">
                <span className="mt-1" data-id="element-345">❌</span>
                <span data-id="element-346">Contenido que te da más trabajo leer</span>
              </li>
            </ul>
          </motion.div>

          {/* Esto SÍ es */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-brand-600 rounded-xl p-8 shadow-md" data-id="element-347">
            <h3 className="text-xl font-bold text-white mb-6" data-id="element-348">Esto SÍ es:</h3>
            <ul className="space-y-4" data-id="element-349">
              <li className="flex items-start gap-3 text-brand-50" data-id="element-350">
                <span className="mt-1" data-id="element-351">✅</span>
                <span className="font-medium" data-id="element-352">
                  Un manual táctico de implementación inmediata
                </span>
              </li>
              <li className="flex items-start gap-3 text-brand-50" data-id="element-353">
                <span className="mt-1" data-id="element-354">✅</span>
                <span className="font-medium" data-id="element-355">
                  Diseñado para el profesional argentino de 2026
                </span>
              </li>
              <li className="flex items-start gap-3 text-brand-50" data-id="element-356">
                <span className="mt-1" data-id="element-357">✅</span>
                <span className="font-medium" data-id="element-358">
                  Con palabras exactas y scripts copiables
                </span>
              </li>
              <li className="flex items-start gap-3 text-brand-50" data-id="element-359">
                <span className="mt-1" data-id="element-360">✅</span>
                <span className="font-medium" data-id="element-361">
                  Aplicable desde la primera noche que lo descargás
                </span>
              </li>
              <li className="flex items-start gap-3 text-brand-50" data-id="element-362">
                <span className="mt-1" data-id="element-363">✅</span>
                <span className="font-medium" data-id="element-364">
                  Sin plataformas, sin logins, sin accesos que vencen
                </span>
              </li>
            </ul>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center bg-white border border-neutral-200 rounded-xl p-8 sm:p-12 shadow-sm" data-id="element-365">
          <p className="text-2xl sm:text-3xl font-bold text-brand-700 italic leading-relaxed font-display" data-id="element-366">
            "Si aplicás solo el 50% de lo que está acá, vas a tener resultados
            antes del día 15."
          </p>
        </motion.div>
      </div>
    </section>;
};